import { IconButton, TableCell, TableRow } from "@mui/material";
import { AreaType } from "../../../../../domain/models/daily-visit-report/dailyVisitReport";
import { useState, useEffect } from "react";
import ArrowCircleDownOutlinedIcon from "@mui/icons-material/ArrowCircleDownOutlined";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import CalendarGridDailyVisitData from "../calender-grid/CalendarGridDailyVisitData";

type Props = {
  data: AreaType;
  month: number;
  year: number;
  totalRegion: number[];
  downloadJson: any[];
  customerTypeId: string | null;
};

const AreaWiseDailyVisit: React.FC<Props> = ({
  data,
  month,
  year,
  totalRegion,
  downloadJson,
  customerTypeId,
}) => {
  const daysInMonth = new Date(year, month, 0).getDate();
  const [totalAll, setTotalAll] = useState<number[]>(
    new Array(daysInMonth).fill(0)
  );
  const [totalRow, setTotalRow] = useState<JSX.Element[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [openRow, setOpenRow] = useState<boolean>(true);

  useEffect(() => {
    setTotalAll(new Array(daysInMonth).fill(0));
  }, [month, year]);

  const areaDataJSON: any = {};
  useEffect(() => {
    if (totalAll.every((value) => value === 0)) {
      return;
    }

    let total = 0;
    for (const item of totalAll) {
      if (typeof item === "number") {
        total += item;
      } else if (item === "H") {
        total += 0;
      }
    }
    setTotal(total);
    areaDataJSON.role = "ABM";
    areaDataJSON.user = data.abm_name;
    areaDataJSON.territory = data.area_name;
    areaDataJSON.total = total;
    totalAll.forEach((total, index) => {
      const dayPropertyName = `${index + 1}`;
      areaDataJSON[dayPropertyName] = total;
    });
    const getDayOfWeek = (day: number) => {
      return new Date(year, month - 1, day).getDay();
    };
    const totalRowCells = totalAll.map((total, index) => {
      const isSunday = getDayOfWeek(index + 1) === 0;
      return (
        <TableCell
          key={index}
          sx={{
            border: "2px solid white",
            textAlign: "center",
            padding: 0.5,
            fontSize: 12,
            backgroundColor: "#b6dffa",
          }}
        >
          {isSunday ? "H" : total}
        </TableCell>
      );
    });
    setTotalRow(totalRowCells);

    const existingIndex = downloadJson.findIndex(
      (item) => item.user === areaDataJSON.user
    );
    if (existingIndex !== -1) {
      downloadJson[existingIndex] = areaDataJSON;
    } else {
      downloadJson.push(areaDataJSON);
    }
  }, [totalAll, month, year]);

  return (
    <>
      <TableRow>
        <TableCell
          sx={{
            border: "2px solid white",
            padding: 0,
          }}
        >
          <IconButton size="small" onClick={() => setOpenRow(!openRow)}>
            {openRow ? (
              <ArrowCircleDownOutlinedIcon fontSize="small" />
            ) : (
              <ArrowCircleRightOutlinedIcon fontSize="small" />
            )}
          </IconButton>
        </TableCell>
        <TableCell
          sx={{
            border: "2px solid white",
            wordWrap: "break-word",
            overflowWrap: "break-word",
            padding: 0,
            fontSize: 12,
            width: 80,
          }}
        >
          {data.abm_name}
        </TableCell>
        <TableCell
          align="center"
          style={{
            border: "2px solid white",
            width: 80,
            wordWrap: "break-word",
            overflowWrap: "break-word",
            padding: 0,
            textAlign: "center",
            cursor: "default",
            fontSize: 12,
          }}
        >
          {data.area_name}
        </TableCell>
        <TableCell
          align="center"
          style={{
            border: "2px solid white",
            padding: 0,
            cursor: "default",
            fontSize: 12,
          }}
        />
        <TableCell
          align="center"
          sx={{
            border: "2px solid white",
            padding: 0,
            fontSize: 12,
          }}
        >
          {total}
        </TableCell>
        {totalRow}
      </TableRow>
      {data.headquarters.map((hq) => (
        <TableRow>
          <CalendarGridDailyVisitData
            open={openRow}
            hq={hq}
            year={year}
            month={month}
            user_id={hq.user_id}
            totalRegion={totalRegion}
            totalArea={totalAll}
            downLoadJson={downloadJson}
            customerTypeId={customerTypeId}
          />
        </TableRow>
      ))}
    </>
  );
};

export default AreaWiseDailyVisit;
